
const style = () => ({
    searchHeader: {
        background: '#fff !important'
    }
});
export default style;